<template>
  <v-container id="user-profile" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" lg="10">
        <base-material-card
          icon="mdi-map-check"
          :title="id ? $i18n.t('Edit Fuel Price') : $i18n.t('Create Fuel Price')"
          class="px-3 py-3 small-icon"
        >
          <v-form id="form" v-model="valid">
            <v-container class="py-0">
              <v-row>
                <v-col cols="12" md="4">
                  <z-date-picker
                    :label="$i18n.t('Date')"
                    class="purple-input"
                    v-model="price.date"
                    :rules="validationrules.date"
                    required
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-checkbox v-model="price.forPump" :label="$i18n.t('')" />
                </v-col>
              </v-row>
              <v-row v-if="price.forPump">
                <v-col cols="12" md="4">
                  <z-fuel-pump-select
                    :label="$i18n.t('Fuel Pump')"
                    class="purple-input"
                    v-model="pump"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <z-currency-select
                    :label="$i18n.t('Currency')"
                    class="purple-input"
                    v-model="price.currency"
                    :rules="validationrules.currency"
                    required
                  />
                </v-col>
              </v-row>
              <v-row v-else>
                <v-col cols="12" md="4">
                  <z-country-select
                    :label="$i18n.t('Country')"
                    class="purple-input"
                    v-model="price.country"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <z-city-select
                    :label="$i18n.t('City')"
                    class="purple-input"
                    v-model="price.city"
                    :country="price.country"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <z-currency-select
                    :label="$i18n.t('Currency')"
                    class="purple-input"
                    v-model="price.currency"
                    :rules="validationrules.currency"
                    required
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="3" dense>
                  <v-text-field :label="$i18n.t('Petrol')" dense v-model="price.petrol"></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field :label="$i18n.t('Diesel')" dense v-model="price.diesel"></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field :label="$i18n.t('CNG')" dense v-model="price.cng"></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field :label="$i18n.t('Electric')" dense v-model="price.elec"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="text-right">
                  <v-btn
                    color="success"
                    class="mr-0"
                    @click="save()"
                    :loading="loading"
                    :disabled="!valid"
                  >
                    <h3>{{ $i18n.t("Save") }}</h3>
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class Tickets extends Vue {
  price = {};
  valid = true;
  id = null;
  markers = [];
  places = [];
  pump = {};
  validationrules = {
    date: [(v) => !!v || this.$i18n.t("Date is required")],
    currency: [(v) => !!v || this.$i18n.t("Currency is required")],
  };
  get loading() {
    return common.loading;
  }

  async save() {
    try {
      let url = "/api/fuelcost/save";
      if (this.price._id) {
        url = "/api/fuelcost/edit";
      }
      common.setLoading(true);
      this.price = await doPost(url, this.price);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  async get(id) {
    try {
      this.price = await doGet("/api/fuelcost/" + id + "/detail");
      this.id = this.price._id;
    } catch (e) {
      common.setError(e.message);
    }
  }

  async mounted() {
    if (this.$route.params.id) {
      await this.get(this.$route.params.id);
    }
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
</style>
